﻿let $ = require('jquery');

$(function () {
	require('./layouts.js');
	require('./widgets.js');
});